<template>
  <v-container fluid class="mb-10">
    <v-row>
      <v-col
        cols="12"
        md="6"
        align="center"
        class="teal-bg black--text text-banner"
      >
        Earn points with every purchase<br> you make through Boodil
      </v-col>

      <v-col
        cols="12"
        md="6"
        align="center"
        class="teal-bg-dark black--text text-banner"
      >
        Download the official Boodil app to<br> be in with a chance of winning a
        holiday
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
.text-banner {
  font-size: 0.875rem !important;
  font-weight: 500;
  line-height: 1.2rem;
  letter-spacing: 0.0892857143em !important;
  font-family: "Roboto", sans-serif !important;
  text-transform: uppercase !important;
}
</style>